import { jsx } from "react/jsx-runtime";
import { createElement, useMemo } from "react";
import classnames from "classnames";
import card from "../card/index.js";
import "./index.css";
const rootClass = 'weet-components-radio-card-group';
function CardGroup(props) {
    const { layout = 'horizontal', options, className, disabled, value, block = false, onChange, onMouseEnter, onMouseLeave, onFocus, onBlur } = props;
    const renderList = useMemo(()=>{
        const style = block && 'horizontal' === layout ? {
            flex: 1,
            maxWidth: '100%'
        } : {};
        return options?.map((item)=>{
            if ('string' == typeof item || 'number' == typeof item) return {
                children: item,
                checked: value === item,
                disabled,
                value: item,
                style,
                onChange
            };
            return {
                ...item,
                desc: item.desc,
                children: item.label,
                checked: item.value === value,
                value: item.value,
                disabled,
                className: item.className,
                style,
                onChange
            };
        }) || [];
    }, [
        options,
        disabled,
        block,
        layout,
        onChange
    ]);
    return /*#__PURE__*/ jsx("div", {
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onFocus: onFocus,
        onBlur: onBlur,
        className: classnames(className, rootClass, `${rootClass}__${layout}`),
        children: renderList?.map((item)=>/*#__PURE__*/ createElement(card, {
                ...item,
                key: item.value
            }))
    });
}
export { CardGroup as default, rootClass };
